export const formatThousandsWithSpace = (number: number) =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
